<template>
  <span>{{ value }}</span>
</template>

<script>
export default {
  name: 'NumberVal',
  props: {
    value: {
      required: true,
    },
  },
};
</script>

<style scoped>

</style>
